// snakeToSentenceCase takes a string in snake_case and converts it to Sentence Case.
export const snakeToSentenceCase = (str: string) => {
  return str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
